const withdraw = {
  draw_bank_account: 'Bank Account',
  draw_bank_name: 'Bank Name',
  draw_beneficiary: 'Beneficiary Name',
  draw_swift: 'Bic Number/SWIFT Code',
  draw_receving: 'Receving Bank Information',
  draw_corres: 'Enter value',
  draw_bank_address: 'Bank Address',
  draw_add_1: 'Address 1',
  draw_add_2: 'Address 2',
  draw_country: 'Country',
  draw_city: 'City',
  draw_post_code: 'Post Code',
  draw_intermediary: 'This bank requires an intermediary',
  draw_inter_name: 'Intermediary Bank Name',
  draw_add_info: 'Additional Information',
  isRequired: 'This field is required',
  least_fifteen: 'At least 4',

}
export default withdraw;


// WEBPACK FOOTER //
// ./src/i18n/english/withdraw.js